import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useInView } from '../hooks/useInView';
import DecadesTimeline, { decades } from './DecadesTimeline';

const DecadesTeaser = () => {
  const [ref, isInView] = useInView({ threshold: 0.15 });
  const [activeDecade, setActiveDecade] = useState(4); // Default to "Today"

  return (
    <section className="bg-[#0a0a0a] py-20 px-6 border-t border-white/[0.06]">
      <div className="max-w-[1320px] mx-auto">
        {/* Header */}
        <div ref={ref} className="text-center mb-12">
          <p
            className="text-[#6a6a6a] text-[13px] mb-3 uppercase tracking-wider"
            style={{
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(10px)',
              transition: 'opacity 0.6s ease, transform 0.6s ease',
            }}
          >
            Our Legacy
          </p>
          <h2
            className="text-[38px] md:text-[46px] font-extralight text-white mb-4 tracking-[-0.02em]"
            style={{
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(10px)',
              transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s',
            }}
          >
            LV1 Throughout the Decades
          </h2>
          <p
            className="text-[#8a8a8a] text-[15px] leading-[1.7] max-w-[500px] mx-auto"
            style={{
              opacity: isInView ? 1 : 0,
              transform: isInView ? 'translateY(0)' : 'translateY(10px)',
              transition: 'opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s',
            }}
          >
            A record of our work, told through the decades of building brands and delivering product.
          </p>
        </div>

        {/* Timeline - using shared component */}
        <div
          className="relative max-w-3xl mx-auto mb-8"
          style={{
            opacity: isInView ? 1 : 0,
            transform: isInView ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.7s ease 0.3s, transform 0.7s ease 0.3s',
          }}
        >
          <DecadesTimeline
            variant="teaser"
            nodeSize={48}
            initialActive={activeDecade}
            onDecadeChange={setActiveDecade}
          />
        </div>

        {/* Description box */}
        <div
          className="max-w-3xl mx-auto"
          style={{
            opacity: isInView ? 1 : 0,
            transform: isInView ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.7s ease 0.4s, transform 0.7s ease 0.4s',
          }}
        >
          <div
            key={activeDecade}
            className="p-6 rounded-[20px] text-center animate-fade-in"
            style={{
              backdropFilter: 'blur(2px)',
              WebkitBackdropFilter: 'blur(2px)',
              backgroundColor: 'rgba(255, 255, 255, 0.02)',
              boxShadow: `inset 0 0 20px rgba(255,255,255,0.05),
                         inset 0 1px 1px rgba(255,255,255,0.1),
                         0px 4px 20px rgba(0,0,0,0.12)`,
              borderTop: '1px solid rgba(255,255,255,0.15)',
              borderLeft: '1px solid rgba(255,255,255,0.1)',
              borderRight: '1px solid rgba(255,255,255,0.05)',
              borderBottom: '1px solid rgba(255,255,255,0.03)',
            }}
          >
            <p className="text-white/70 text-[15px] leading-[1.7]">
              {decades[activeDecade].shortDesc}
            </p>
          </div>
        </div>

        {/* CTA */}
        <div
          className="flex justify-center mt-10"
          style={{
            opacity: isInView ? 1 : 0,
            transform: isInView ? 'translateY(0)' : 'translateY(10px)',
            transition: 'opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s',
          }}
        >
          <Link
            to="/history"
            className="px-6 py-3 border border-white/20 text-white rounded-full text-[14px] font-medium hover:bg-white/5 hover:border-white/30 transition-all duration-300"
          >
            Explore Our Story
          </Link>
        </div>
      </div>

      {/* Fade-in animation for content changes */}
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.35s ease-out;
        }
      `}</style>
    </section>
  );
};

export default DecadesTeaser;
